// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"401":"fb1f8547","591":"6a2fbfc8"}[chunkId] + ".css";
};